import { Badge } from '@/components/ui/badge';
import { SOP_APPROVAL_STATUS_CONFIG } from '@/modules/sop';
import type { SOP } from '@/types';

/**
 * Approval decides Draft/Approved, and `enabled` is the separate runtime flag for
 * whether the AI is using the SOP. The raw `status` says "draft" even on approved
 * SOPs, so it is never shown.
 */
export const SopState = ({ sop }: { sop: SOP }) => {
	const approval = SOP_APPROVAL_STATUS_CONFIG[sop.approvalStatus];
	return (
		<span className='flex shrink-0 items-center gap-1'>
			<Badge
				variant='outline'
				className={`rounded-full border-0 text-[11px] font-medium ${approval.bgColor} ${approval.textColor}`}
			>
				{approval.label}
			</Badge>
			{sop.enabled && (
				<Badge variant='outline' className='rounded-full border-0 bg-emerald-50 text-[11px] font-medium text-emerald-600'>
					Active
				</Badge>
			)}
		</span>
	);
};
